// extracted by mini-css-extract-plugin
module.exports = {"main":"InviteUser_main__TeUIz"};